import { render, staticRenderFns } from "./createDetail.vue?vue&type=template&id=a6d8909c&scoped=true"
import script from "./createDetail.vue?vue&type=script&lang=js"
export * from "./createDetail.vue?vue&type=script&lang=js"
import style0 from "./createDetail.vue?vue&type=style&index=0&id=a6d8909c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d8909c",
  null
  
)

export default component.exports